import http from '../http-common';

class CandidateDataService {
  getAll() {
    return http.get(`/user?_t=${Date.now()}`);
  }
  getAllUser() {
    return http.get(`/user?_t=${Date.now()}`);
  }

  updateStatus(id, status){
    return http.post(`/user/status-update/${id}`, status);
  }

  getAllAcno() {
    return http.get("/acno-list");
  }

  get(id) {
    return http.get(`/user/edit/${id}`);
  }

  getAdmin(id) {
    return http.get(`/user/edit/${id}`);
  }

  create(data) {
    return http.post("/user/user-register", data);
  }

  createAdmin(data) {
    return http.post("/new-admin-register", data);
  }
  update(data) {
    return http.post(`/user/update`, data);
  }
  updateAdmin(id, data) {
    return http.post(`/user/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/candidate/delete/${id}`);
  }
}

export default new CandidateDataService();
